export const ACTION_ADD_POSTBACK_SETTINGS = 'ACTION_ADD_POSTBACK_SETTINGS';

export const ACTION_LOAD_POSTBACK_SETTINGS__REQUEST = 'ACTION_LOAD_POSTBACK_SETTINGS__REQUEST';
export const ACTION_LOAD_POSTBACK_SETTINGS__SUCCESS = 'ACTION_LOAD_POSTBACK_SETTINGS__SUCCESS';
export const ACTION_LOAD_POSTBACK_SETTINGS__FAIL = 'ACTION_LOAD_POSTBACK_SETTINGS__FAIL';

export const ACTION_EDIT_POSTBACK_SETTINGS__REQUEST = 'ACTION_EDIT_POSTBACK_SETTINGS__REQUEST';
export const ACTION_EDIT_POSTBACK_SETTINGS__SUCCESS = 'ACTION_EDIT_POSTBACK_SETTINGS__SUCCESS';
export const ACTION_EDIT_POSTBACK_SETTINGS__FAIL = 'ACTION_EDIT_POSTBACK_SETTINGS__FAIL';

export const ACTION_TEST_POSTBACK_SETTINGS__REQUEST = 'ACTION_TEST_POSTBACK_SETTINGS__REQUEST';
export const ACTION_TEST_POSTBACK_SETTINGS__SUCCESS = 'ACTION_TEST_POSTBACK_SETTINGS__SUCCESS';
export const ACTION_TEST_POSTBACK_SETTINGS__FAIL = 'ACTION_TEST_POSTBACK_SETTINGS__FAIL';
